/* tslint:disable:no-console */

import { LoggerTypeEnum } from '@/enums/LoggerTypeEnums';

export default class Logger {
    /**
     * Credits: https://refactoring.guru/design-patterns/singleton/typescript/example
     */
    private static instance: Logger;

    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    private constructor() { }

    /**
     * The static method that controls the access to the singleton instance.
     *
     * This implementation let you subclass the Singleton class while keeping
     * just one instance of each subclass around.
     */
    // tslint:disable-next-line: member-ordering
    public static getInstance(): Logger {
        if (!Logger.instance) {
            Logger.instance = new Logger();
        }

        return Logger.instance;
    }

    // tslint:disable-next-line: member-ordering
    public defaultLogLevel: LoggerTypeEnum = LoggerTypeEnum.WARN;

    public Log(type: LoggerTypeEnum, message: string, ...optionalParams: any[]) {
        switch (type) {
            case LoggerTypeEnum.DEBUG:
                if (this.defaultLogLevel <= LoggerTypeEnum.DEBUG) {
                    if (console.debug) {
                        console.debug(message, ...optionalParams);
                    } else {
                        console.log('Debug: ' + message, ...optionalParams);
                    }
                }
                break;
            case LoggerTypeEnum.INFO:
                if (this.defaultLogLevel <= LoggerTypeEnum.INFO) {
                    if (console.info) {
                        console.info(message, ...optionalParams);
                    } else {
                        console.log('Info: ' + message, ...optionalParams);
                    }
                }
                break;
            case LoggerTypeEnum.WARN:
                if (this.defaultLogLevel <= LoggerTypeEnum.WARN) {
                    if (console.warn) {
                        console.warn(message, ...optionalParams);
                    } else {
                        console.log('Warning: ' + message, ...optionalParams);
                    }
                }
                break;
            case LoggerTypeEnum.ERROR:
                if (this.defaultLogLevel <= LoggerTypeEnum.ERROR) {
                    if (console.error) {
                        console.error(message, ...optionalParams);
                    } else {
                        console.log('Error: ' + message, ...optionalParams);
                    }
                }
                break;
            default:
                if (this.defaultLogLevel <= LoggerTypeEnum.DEBUG) {
                    console.log('Verbose: ' + message, ...optionalParams);
                }
                break;
        }
    }

    public LogDebug(message: string, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.DEBUG, message, optionalParams);
    }

    public LogInfo(message: string, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.INFO, message, optionalParams);
    }

    public LogWarn(message: string, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.WARN, message, optionalParams);
    }

    public LogError(message: string, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.ERROR, message, optionalParams);
    }

    public error(message?: any, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.ERROR, message, optionalParams);
    }
    public info(message?: any, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.INFO, message, optionalParams);
    }
    public debug(message?: any, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.DEBUG, message, optionalParams);
    }
    public warn(message?: any, ...optionalParams: any[]) {
        this.Log(LoggerTypeEnum.WARN, message, optionalParams);
    }
}
